"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: t, size: s = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = n(), o = t !== null && t !== void 0 ? t : c ? e.colors.inverse : e.colors.neutralHigh;
    return /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: s,
        height: s,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M16.455 11.998c0 2.543-2.003 4.605-4.473 4.605s-4.473-2.062-4.473-4.605 2.003-4.605 4.473-4.605 4.473 2.062 4.473 4.605"
            }),
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M22 12.146c-.036 0-.036.037-.036.037-.02.021-.03.03-.033.041q-.004.011-.003.033v.037C20.104 16.496 16.383 19 11.982 19s-8.122-2.504-9.946-6.631v-.037c-.02-.022-.03-.03-.033-.042q-.004-.01-.003-.033v-.444c.02-.022.03-.03.033-.042q.004-.01.003-.033v-.037C3.86 7.504 7.581 5 11.982 5s8.122 2.504 9.982 6.664v.037c.02.022.03.03.033.041q.004.012.003.033zm-18.532-.148c1.645 3.46 4.793 5.523 8.514 5.523s6.87-2.06 8.514-5.523c-1.645-3.464-4.793-5.523-8.514-5.523s-6.87 2.059-8.514 5.523"
            })
        ]
    }));
}, h = v;
export { h as default };
